import { FileData } from '@bucketplace/commerce-admin-ui';

export function validateImageURL(url: string): Promise<FileData> {
  return new Promise((resolve, reject) => {
    const image = new Image();
    image.onload = () => {
      const dimensions = {
        width: image.naturalWidth,
        height: image.naturalHeight,
        url,
      };
      resolve(dimensions);
    };
    image.onerror = image.onabort = reject;
    image.src = url;
  });
}
